import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@fortawesome/fontawesome-free/css/all.min.css";

import { BrowserRouter } from 'react-router-dom';


const loadEasebuzzScript = () => {
  const existingScript = document.querySelector(
    "script[src='https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js']"
  );
  if (!existingScript) {
    const script = document.createElement("script");
    script.src =
      "https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js";
    script.async = true;
    document.body.appendChild(script);
  }
};
loadEasebuzzScript();


//✅ Apply colors from localStorage globally colors stays after refresh 
const colorsString = localStorage.getItem("appConfig");
if (colorsString) {
  const storedColors: { [key: string]: string } = JSON.parse(colorsString);
  Object.entries(storedColors).forEach(([key, value]) => {
    document.documentElement.style.setProperty(`--${key}`, value);
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* ✅ Wrap App in Router */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
